import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { YarnBall } from "@/components/yarn/YarnBall";

export function PageHeader({ title, back = "/lobby", right }) {
  return (
    <header className="topbar sticky top-0 z-30">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 h-16 flex items-center gap-3">
        <Link to={back} className="btn-soft h-10 w-10 grid place-items-center shrink-0" aria-label="Back" data-testid="page-back-button">
          <ArrowLeft size={18} />
        </Link>
        <YarnBall size={30} />
        <h1 className="font-display text-xl font-semibold truncate flex-1">{title}</h1>
        {right}
      </div>
    </header>
  );
}
